import REPORT from "./Report";

export { REPORT };



// WEBPACK FOOTER //
// src/modules/screens/reporting/AgentCareerStatus/components/index.js